import { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { toast } from 'react-toastify';

// Plain-text rendering of the whole list: a numbered citation per entry, with
// the URL/DOI indented underneath when present.
const buildReferenceList = (references) =>
  references
    .map((r, i) => {
      const lines = [`${i + 1}. ${r.reference}`];
      if (r.url) lines.push(`   ${r.url}`);
      return lines.join('\n');
    })
    .join('\n\n');

// "Download Entire Reference List" link + dropdown (Download .txt / Copy). Shared
// by the References panel and the View List dialog so both behave identically.
const DownloadReferenceList = ({ references = [] }) => {
  const [anchor, setAnchor] = useState(null);
  const close = () => setAnchor(null);

  const handleDownloadTxt = () => {
    close();
    const blob = new Blob([buildReferenceList(references)], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'references.txt';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleCopyToClipboard = async () => {
    close();
    try {
      await navigator.clipboard.writeText(buildReferenceList(references));
      toast.success('Reference list copied to clipboard', { className: 'toast', autoClose: 3000 });
    } catch (err) {
      console.error('Failed to copy reference list:', err);
      toast.error('Could not copy to clipboard', { className: 'toast', autoClose: 3000 });
    }
  };

  return (
    <div className="references-download">
      <button
        type="button"
        className="references-link-btn"
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        Download Entire Reference List
      </button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={close}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <MenuItem onClick={handleDownloadTxt}>Download .txt file</MenuItem>
        <MenuItem onClick={handleCopyToClipboard}>Copy to Clipboard</MenuItem>
      </Menu>
    </div>
  );
};

export default DownloadReferenceList;
